import React from 'react';
import MDBox from 'components/MDBox';
import Divider from '@mui/material/Divider';
import { handleBooleanProp } from 'utils/commonUtils';
import {
  SidebarCheckBoxIcon,
  SsaSectionTypography,
  SsaSidebarListWrapper,
  SsaSidebarStudentItem,
} from 'layouts/studentSuccessAdvocate/ssa/components/ssaComponentStyled';
import { sortStudentsAZ } from 'layouts/studentSuccessAdvocate/ssa/components/ssaCommonUtils';

const SsaSidenavCompletedStudentsSection = ({
  show,
  dividerLight,
  onStudentClick,
  activeStudentId,
  completedStudents,
}) => {
  if (!show) return null;

  const sortedCompletedStudents = sortStudentsAZ(completedStudents || []);

  return (
    <>
      <Divider light={dividerLight} />

      <MDBox px={1}>
        <SsaSectionTypography variant="caption">
          COMPLETED STUDENTS
        </SsaSectionTypography>

        <SsaSidebarListWrapper>
          {sortedCompletedStudents?.map((student, index) => (
            <SsaSidebarStudentItem
              onClick={() => onStudentClick(student)}
              isapierror={handleBooleanProp(student.apiError)}
              key={`${student.id}-${student.lastName}-${index}`}
              isactive={handleBooleanProp(student.id === activeStudentId)}
            >
              {student?.inCompliance && !student?.apiError && (
                <SidebarCheckBoxIcon
                  isactive={handleBooleanProp(student?.id === activeStudentId)}
                />
              )}
              {student.lastName}, {student.firstName} ID:{student.id} Grade:
              {student.grade}
            </SsaSidebarStudentItem>
          ))}
        </SsaSidebarListWrapper>
      </MDBox>
    </>
  );
};

export default SsaSidenavCompletedStudentsSection;
